var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.remove()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("remove_circle")])],1),_c('span',[_vm._v("Remove")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }